import { FC } from 'react'
import { Icon, IconNode } from 'lucide-react'

// From https://github.com/mui/material-ui/blob/4c336b8bd492749117a34947db44b0157a44c18b/packages/mui-icons-material/lib/esm/DeveloperBoard.js#L6
const developerBoardNode: IconNode = [
  [
    'path',
    {
      d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9zm-4 10H4V5h14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z',
      fill: 'currentColor',
      stroke: 'none',
      key: 'developer-board-path',
    },
  ],
]

export const DeveloperBoard: FC<{ className?: string; size?: number }> = ({ className, size = 24 }) => {
  return <Icon iconNode={developerBoardNode} size={size} className={className} />
}
